import { Column, Row, Text, ThemeText } from '@/components/Theme';
import isEqual from 'lodash/isEqual';
import { memo } from 'react';
import FormatPrice from './FormatPrice';
import RegularPrice from './RegularPrice';
import SpecialPrice from './SpecialPrice';

const ProductPrice = (props) => {

    const {
        rangeTextProps = {},
        regularPriceProps = {},
        specialPriceProps = {},
        uvpProps = {},
        uvpPriceProps = {},

        regularPrice = null,
        specialPrice = null,
        finalPrice = null,
        uvp = null,

        currency = 'EUR',
        hasSpecialPrice = false,
        isSpecialPriceActive = false,
        typename = 'regular',
        horizontal = false,
        containerProps = {}
    } = props || {};
    
    const Wrapper = horizontal ? Row : Column;

    return (
        <Wrapper gap={0} justifyContent={'flex-end'} alignItems={'flex-end'} {...containerProps}>
            
            {regularPrice > 0 && 
                
                <Row gap={5} alignItems={'flex-end'}>
                    {typename == 'range' &&
                        <ThemeText variant={'small'} id={'price.startsFrom'} style={{marginBottom: 2}} {...rangeTextProps}  />
                    }
                    
                    <RegularPrice
                        price={regularPrice} 
                        currency={currency} 
                        lineThrough={hasSpecialPrice && isSpecialPriceActive}
                        lineTroughColor={'black'}
                        {...regularPriceProps}
                    />
                </Row>
                
            }

            {hasSpecialPrice && isSpecialPriceActive && (specialPrice ?? finalPrice) > 0 && 
                <SpecialPrice
                    price={(specialPrice ?? finalPrice)} 
                    currency={currency} 
                    {...specialPriceProps}
                />
            }

            {uvp > 0 && finalPrice < uvp && 
                <ThemeText variant={['small', 'white', 'muted']} {...uvpProps}>
                    <Text id={'price.uvp'} append={': '} />
                    <FormatPrice 
                        price={uvp}
                        currency={currency}
                        variant={null}
                        themed={false}
                        {...uvpPriceProps}
                    />
                </ThemeText>
            }
        </Wrapper>

    )

};

export { default as FormatPrice } from "./FormatPrice";
export { default as RegularPrice } from "./RegularPrice";
export { default as SpecialPrice } from "./SpecialPrice";

export default memo(ProductPrice, isEqual);